export default __webpack_public_path__ + "static-front/media/MoneyIcon.45418dfb.svg";